import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	videoThumbnailAltText: {
		id: 'search-graph-video.video-thumbnail-alt-text',
		defaultMessage: 'Video thumbnail',
		description: 'Video thumbnail alt text',
	},
	videoIconLabel: {
		id: 'search-graph-video.video-icon-label',
		defaultMessage: 'video icon',
		description: 'Video icon label',
	},
	dropdownMessage: {
		id: 'search-graph-video.dropdown-message',
		defaultMessage:
			'{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
		description: 'Dropdown message for video search result',
	},
	videoType: {
		id: 'search-graph-video.video-type',
		defaultMessage: 'Video',
		description: 'Video type label',
	},
	durationInSeconds: {
		id: 'search-graph-video.duration.seconds',
		defaultMessage: '{seconds} sec',
		description: 'Seconds unit display for video duration',
	},
	durationInMinutes: {
		id: 'search-graph-video.duration.minutes',
		defaultMessage: '{minutes} min',
		description: 'Minutes unit display for video duration',
	},
	durationInHours: {
		id: 'search-graph-video.duration.hours',
		defaultMessage: '{hours} hour {minutes} min',
		description: 'Hours unit display for video duration',
	},
});
